const type = 'SET_RECHARGE_COPIED';

const setRechargeCopied = (data) => ({
  data,
  type,
});

export { type };
export default setRechargeCopied;
